var map = {
	"./AUTEX.png": 8070,
	"./BASUALDO.png": 1344,
	"./COROBRA.png": 5831,
	"./DANICA.png": 605,
	"./DEICO.png": 3547,
	"./DELTA.png": 5521,
	"./DULCOR.jpg": 8474,
	"./EPEC.png": 1192,
	"./F2J.png": 6593,
	"./FAME.png": 5858,
	"./FARMACITY.png": 1307,
	"./FRC.png": 7552,
	"./GAMA.png": 8713,
	"./GESTAMP.png": 8238,
	"./HIDROACCESORIOS.png": 1554,
	"./HORIZONTE.png": 8219,
	"./ITR.jpeg": 5065,
	"./IVECO.png": 4395,
	"./LAMARCHESINA.png": 6067,
	"./LORENZATI.png": 7643,
	"./MM.png": 6609,
	"./MTIDEAS.png": 8142,
	"./NUTRIEN.png": 8012,
	"./PRAX.png": 7142,
	"./PRITTY.png": 1271,
	"./RDC.png": 1614,
	"./ROLA.png": 4087,
	"./SOGEFI.png": 6434,
	"./STELLANTIS.png": 4722,
	"./TARANTO.png": 1428,
	"./TGN.png": 6180,
	"./UBP.png": 8268,
	"./UEB.png": 6599,
	"./UNC.png": 8915,
	"./VANOLI.png": 7796,
	"./VELEZ.png": 7427,
	"./YUSPE.jpg": 9599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;